import React, {useEffect} from 'react';

import CompanyCard from './CompanyCard';
import RoleCard from './RoleCard';
import DocumentHeader from '../../components/DocumentHeader';
import {useAnalytics} from '../../hooks';

const DirectoryPage = ({title, companies = [], roles = []}) => {
  const {tracker} = useAnalytics();

  useEffect(() => {
    tracker.directoryView({title});
  }, []);

  return (
    <div className="pt-10 pb-20 px-4 bg-white">
      <DocumentHeader title={title} />
      <div className="flex flex-col items-start max-w-6xl mx-auto mb-10">
        <h1 className="text-2xl md:text-4xl font-bold mb-5">
          {title}
        </h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto gap-6">
        {companies.length > 0 && (
          companies.map((company) => <CompanyCard company={company} key={company.id} />))}
        {roles.length > 0 && (
          roles.map((role) => <RoleCard role={role} key={role.id} />))}
      </div>
    </div>
  );
};

export default DirectoryPage;
